import React from 'react';

import DotsLoading from '../../../../components/dotsLoading';
import {IChoosed} from '..';
import usePaymentStorePlans from '../../../../services/hookService/plans/postPaymentStorePlans/usePaymentStorePlans';
import {useNavigate} from 'react-router-dom';
interface StepThreeProps {
  paymentWay?: string;

  choosed: IChoosed;
  setStepChoosed: React.Dispatch<React.SetStateAction<string | undefined>>;
  setpaymentWay: React.Dispatch<React.SetStateAction<string | undefined>>;
}
const StepThree = ({
  paymentWay,
  choosed,
  setStepChoosed,
  setpaymentWay,
}: StepThreeProps) => {
  const {isLoading, mutate} = usePaymentStorePlans();
  const navigate = useNavigate();
  return (
    <div className="flex w-full flex-col py-2">
      <p className="text-sm font-Medium">انتخاب روش پرداخت</p>
      <div className="flex flex-col gap-3 pb-3">
        {paymnetWays.map((item, index) => (
          <div className="flex items-center gap-2" key={index}>
            <input
              id={item.value}
              value={item.value}
              name="platform"
              type="radio"
              checked={paymentWay === item.value}
              onChange={e => setpaymentWay(e.target.value)}
            />
            <label className="flex gap-2" htmlFor={item.value}>
              {item.image && (
                <img width={30} height={38} src={item.image} alt={item.value} />
              )}
              <div className="flex flex-col">
                <span className="text-gray-950 text-md font-Regular">
                  {item.label}
                </span>

                {item.descirption && (
                  <span className="text-gray-700 text-sm font-Regular">
                    {item.descirption}
                  </span>
                )}
              </div>
            </label>
          </div>
        ))}
      </div>
      <div className="flex w-full justify-between gap-2">
        <button
          disabled={paymentWay ? false : true}
          className="bg-farm-shop-500 h-[48px] w-[60%] px-2 rounded-[8px] flex items-center justify-center text-white text-md font-Medium"
          onClick={() => {
            paymentWay === 'CardToCard'
              ? navigate(`/upgrade/plan/card_to_card/${choosed.guid}`, {
                  state: {choosed},
                })
              : mutate({ipg_type: paymentWay || '', plan_guid: choosed.guid});
          }}
        >
          {isLoading ? <DotsLoading /> : 'پرداخت'}
        </button>
        <button
          className="border border-farm-shop-500 text-farm-shop-500 h-[48px] w-[40%] px-2 rounded-[8px] flex items-center justify-center  text-md font-Medium"
          onClick={() => setStepChoosed('stepOne')}
        >
          بازگشت
        </button>
      </div>
    </div>
  );
};

export default StepThree;
const paymnetWays = [
  {
    label: 'پرداخت آنلاین',
    descirption: 'درگاه پرداخت  پارسیان',
    value: 'tap',
    image: 'https://s3.ir-thr-at1.arvanstorage.ir/payment/parsian_logo.svg',
  },
  {
    label: 'پرداخت آنلاین',
    descirption: 'درگاه پرداخت ملی',
    value: 'sadad',
    image: 'https://s3.ir-thr-at1.arvanstorage.ir/payment/meli_logo.svg',
  },
  {
    label: 'پرداخت کارت به کارت',
    descirption: null,
    value: 'CardToCard',
    image: null,
  },
];
